<template>
  <ContentBox :title="'我的资源'" :normal-bg="'long_bg'">
    <div class="real-time-info">
      <div class="real-time-info-container">
        <div class="list-box">
          <div class="box-item">
            <img src="@/assets/black_imgs/resource1.png" alt="" class="box-item-img" />
            <div class="box-item-num">{{ formatNumber(basicInfo.material_detail.gem) || 0 }}</div>
          </div>
          <div class="box-item">
            <img src="@/assets/black_imgs/resource2.png" alt="" class="box-item-img" />
            <div class="box-item-num">{{ formatNumber(basicInfo.material_detail.credit) || 0 }}</div>
          </div>
          <div class="box-item">
            <img src="@/assets/black_imgs/resource3.png" alt="" class="box-item-img" />
            <div class="box-item-num">{{ formatNumber(basicInfo.gold_mileage_ticket) || 0 }}</div>
          </div>
          <div class="box-item">
            <img src="@/assets/black_imgs/resource4.png" alt="" class="box-item-img" />
            <div class="box-item-num">{{ formatNumber(basicInfo.silver_mileage_ticket) || 0 }}</div>
          </div>
          <div class="box-item">
            <img src="@/assets/black_imgs/resource5.png" alt="" class="box-item-img" />
            <div class="box-item-num">{{ formatNumber(basicInfo.material_detail.battle_data_set) || 0 }}</div>
          </div>
          <div class="box-item">
            <img src="@/assets/black_imgs/resource6.png" alt="" class="box-item-img" />
            <div class="box-item-num">{{ formatNumber(basicInfo.material_detail.core_dust) || 0 }}</div>
          </div>
          <div class="box-item">
            <img src="@/assets/black_imgs/resource7.png" alt="" class="box-item-img" />
            <div class="box-item-num">{{ formatNumber(basicInfo.material_detail.recruit_voucher) || 0 }}</div>
          </div>
          <div class="box-item">
            <img src="@/assets/black_imgs/resource8.png" alt="" class="box-item-img" />
            <div class="box-item-num">{{ formatNumber(basicInfo.material_detail.advanced_recruit_voucher) || 0 }}</div>
          </div>
        </div>
      </div>
      <div class="container-bottom">
        <div class="bottom-block bottom-block-l"></div>
        <div class="bottom-block bottom-block-r"></div>
      </div>
    </div>
  </ContentBox>
</template>
<script>
import ContentBox from "./ContentBox.vue";

export default {
  name: "RealTimeInfo",
  props: {
    basicInfo: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ContentBox
  },
  methods: {
    formatNumber(num) {
      const str = num.toString();
      if (str.length >= 10) {
        return str.substring(0, 4) + "M";
      } else if (str.length >= 7) {
        return str.substring(0, 4) + "k";
      } else {
        return str;
      }
    }
  }
};
</script>

<style scoped lang="less">
.real-time-info {
  margin-bottom: 10px;
  border-radius: 0 0 10px 10px;

  .real-time-info-container {
    width: 100%;
    background: #fafbfc;
    border-radius: 0 0 10px 10px;

    .list-box {
      padding: 14px;
      display: grid;
      grid-template-columns: repeat(8, 1fr);
      gap: 8px;

      .box-item {
        height: 32px;
        border-radius: 8px;
        border: 1px solid #3490e6;
        display: flex;
        justify-content: center;
        align-items: center;

        .box-item-img {
          width: 26px;
          height: 26px;
          margin-right: 6px;
        }

        .box-item-num {
          height: 18px;
          display: flex;
          color: #333333;
          justify-content: center;
          align-items: center;
          font-weight: 400;
          font-size: 12px;
        }
      }
    }
  }

  .container-bottom {
    width: 100%;
    height: 6px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ffffff;

    .bottom-block {
      width: 8px;
      height: 2px;
      background: #3490e6;
    }

    .bottom-block-l {
      margin-left: 14px;
    }

    .bottom-block-r {
      margin-right: 14px;
    }
  }
}
</style>
